import React from "react";

import { BrandLicense } from "custom-types/Brand";

type Props = {
  brandLicenses: Array<BrandLicense>;
};

const BrandLicenses: React.FC<Props> = ({ brandLicenses }) => {
  return (
    <div className="mt-xxl">
      State License(s)
      {brandLicenses.map((license: BrandLicense) => (
        <div data-testid="brand-license" key={license.licenseNumber}>
          {license.licenseNumber}
        </div>
      ))}
    </div>
  );
};

export default BrandLicenses;
